module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: _vm.$style.root
  }, [(_vm.loading) ? _c('loading') : [(!_vm.error) ? [_c('h2', [_vm._v(_vm._s(_vm.customer.name))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('customer-info', {
    attrs: {
      "model": _vm.customer,
      "fields": _vm.customerFields
    }
  })], 1), _c('div', {
    staticClass: "col-md-12 mt-4"
  }, [_c('box-widget', {
    attrs: {
      "icon": "flag"
    }
  }, [_c('template', {
    slot: "head"
  }, [_vm._v(_vm._s(_vm.$t('customer_field.title.landing-pages')))]), (_vm.customer.landingpages) ? _c('template', {
    slot: "content"
  }, _vm._l((_vm.customer.landingpages), function(page) {
    return _c('b-link', {
      key: page.id,
      staticClass: "d-block",
      attrs: {
        "href": page.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(page.link))])
  })) : [_vm._v("-")]], 2)], 1), _c('div', {
    staticClass: "col-md-12 mt-4"
  }, [_c('notifications', {
    attrs: {
      "data": _vm.notifications,
      "loading": _vm.notificationsLoading
    },
    on: {
      "load": _vm.getMoreNotifications
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(item) {
        return [_c('b', [_vm._v(_vm._s(_vm.$t('fn.complex.notification', {
          type: item.item.type
        })) + ":")]), _vm._v(" " + _vm._s(_vm.createNotificationText(item.item)))]
      }
    }])
  })], 1)])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('campaigns', {
    attrs: {
      "items": _vm.campaigns,
      "loading": _vm.campaignsLoading
    },
    on: {
      "load": _vm.getMoreCampaigns
    }
  })], 1)])])])] : [([404, 403].includes(_vm.error.code)) ? _c('not-found') : _c('h1', [_vm._v(_vm._s(_vm.error))])]]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef86dcae"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/customer/Customer.vue
// module id = 2101
// module chunks = 1